<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">CARICAMENTO ORARI APPUNTAMENTI STORE</div>
  </div>
  
  <!-- Modal body -->
  <div class="modal-body mx-2">
    <app-openingclosinghours-table [inputOpeningclosinghoursTable]="inputOpeningclosinghoursTable"
      (outputOpeningclosinghoursTable)="changeTableHours($event)">
    </app-openingclosinghours-table>
    <!--Buttons-->
    <div class="my-3 text-center">
      <button type="button" class="btn btn-fw text me-3" (click)="saveOpeningclosinghours()"
        [disabled]="!isValidOpeningclosinghours">Salva modifiche</button>
      <button type="button" class="btn btn-outline-fw text" (click)="cancel()">Annulla</button>
    </div>
  </div>